const Style = {
    stack: 'flex flex-col gap-4',
    grid: 'grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
};

export default Style;
